module.exports = __webpack_public_path__ + "static/media/assessments-background.6b83efd5.jpg";